'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
const AsyncSaveTemplateUpgradeModal = Loadable({
  loader: () => import( /* webpackChunkName: "ui-addon-upgrades" */'EmailComponents/modals/upgrade/SaveTemplateUpgradeModal'),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncSaveTemplateUpgradeModal;